import { render } from "./tasks.vue?vue&type=template&id=4fba0f4a&scoped=true"
import script from "./tasks.vue?vue&type=script&lang=js"
export * from "./tasks.vue?vue&type=script&lang=js"

import "./tasks.vue?vue&type=style&index=0&id=4fba0f4a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fba0f4a"]])

export default __exports__